import React from "react";
import { Box, Grid, Typography, IconButton } from "@mui/material";
import { IoMdAdd } from "react-icons/io";

const ReservationsCard = ({
  reservationNumber,
  dateOfReservation,
  firstName,
  lastName,
  email,
  paymentDate,
  payWay,
  status,
  note,
  numberOfPersons,
  onClick,
  extraObjectsList,
  totalPackagePrice,
  totalExtraObjectsPrice,
  totalPrice,
  name
}) => {
  return (
    <Box>
      <Box sx={{
        mt: 3,
        bgcolor: "white",
        py: 6,
        px: 6,
        borderRadius: "8px",
      }}>
        <Grid container spacing={6}>
          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              fontFamily: "Noto Sans JP",
              color: "#CD9D41",
              fontSize: "20px",
            }}>
              Buchungsnummer:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {reservationNumber}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              fontFamily: "Noto Sans JP",
              color: "#CD9D41",
              fontSize: "20px",
            }}>
              Vorname:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {firstName}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Nachname:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {lastName}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Email:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {email}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Reservierungsdatum:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {dateOfReservation}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Enddatum der Reservierung:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {paymentDate}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Zahlungsmethode:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {payWay}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Anzahl der Personen
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {numberOfPersons}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Paketname
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {name}
            </Typography>
          </Grid>

          <Grid display="flex" size={6} gap={1} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Extra:
            </Typography>
            <Box>
              {extraObjectsList?.map((item, index) => (
                <Typography key={index} sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
                    Name: {item.name}, Anzahl der Extras: {item.number}, Price: {item.price}€
                </Typography>
              ))}
            </Box>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Gesamtpaketpreis:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {totalPackagePrice}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              
              Extrapreis:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {totalExtraObjectsPrice}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Gesamtpreis:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {totalPrice}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Status:
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {status}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Notiz
            </Typography>
            <Typography sx={{ fontFamily: "Noto Sans JP", fontSize: "18px" }}>
              {note}
            </Typography>
          </Grid>

          <Grid display="flex" gap={2} size={6} alignItems="center">
            <Typography sx={{
              color: "#CD9D41",
              fontFamily: "Noto Sans JP",
              fontSize: "20px",
            }}>
              Admin Notiz:
            </Typography>
            <IconButton onClick={onClick}>
              <IoMdAdd color="#36D06A" style={{ zIndex: "100px" }} />
            </IconButton>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default ReservationsCard;